import 'intersection-observer'
import * as React from 'react'
import { InView } from 'react-intersection-observer'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { blockInviewHandler } from '../../../../drupal/rendering/inview_utils.mod'
import { ParsedLinkItem } from '../../../../drupal/types_and_parser/types'
import { CMSState } from '../../../drupalPage/state'
import { List } from 'immutable'

export type CardItemProps = {
  field_title: string
  field_introduction: string
  field_link?: ParsedLinkItem | null
}

export type CardsBlockProps = {
  blockIndex: number
  title?: string
  introduction?: string
  items: List<CardItemProps>
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type cardsBlockStyle = Partial<{
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  cards_container_classname: string
  card_classname: string
  card_item_classname: string
  card_label_classname: string
  card_title_classname: string
  card_intro_classname: string
  card_link_classname: string
}>

export function cardsBlock(
  props: CardsBlockProps,
  options?: { style?: cardsBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX(
      setState => {
        return (
          <InView
            as="section"
            onChange={(inView) =>
              blockInviewHandler(
                'cardsBlock',
                inView,
                `io-${options && options.key ? options.key : props.blockIndex}`,
                getClassName(options, 'inview_classname', 'inview')
              )
            }
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.blockIndex}`}
            className={getClassName(options, 'block_contentwidth_classname', 'block block--cards')}
            key={options && options.key ? options.key : `block-${props.blockIndex}`}
          >
            <div className={getClassName(options, 'inner_classname', 'cards__container container container--m grid--gutter')}>
              {props.title && (
                <div className={getClassName(options, 'header_classname', 'block__header')}>
                  <h2 className={getClassName(options, 'title_classname', 'block__title title--l')}>
                    {props.title}
                  </h2>
                   {props.introduction && (
                      <div
                        className="block__intro text--styled text--l"
                        dangerouslySetInnerHTML={{ __html: props.introduction }}
                      />
                    )}
                </div>
              )}
              <div className={getClassName(options, 'cards_container_classname', 'cards__grid')}>
                {props.items.toArray().map((item, index) => (
                  <div
                    key={`card-${index}`}
                    className={getClassName(options, 'card_item_classname', 'cards__item')}
                  >
                    <div
                      className={getClassName(options, 'card_classname', 'card')}
                    >
                      {item.field_title && (
                        <h3 className={getClassName(options, 'card_title_classname', 'card__title title--l')}>
                          {item.field_title}
                        </h3>
                      )}
                      {item.field_introduction && (
                        <div
                          className={getClassName(options, 'card_intro_classname', 'card__intro text--styled text--l')}
                          dangerouslySetInnerHTML={{ __html: item.field_introduction }}
                        />
                      )}
                      {item.field_link && item.field_link.url && (
                        <a
                          href={item.field_link.url}
                          className={getClassName(options, 'card_link_classname', 'card__link button')}
                          onClick={() => {
                            window.dataLayer.push({
                              event: 'event.refresco',
                              category: 'CardsBlock',
                              action: item.field_link?.title || 'Card Link',
                              label: window.location.pathname
                            })
                          }}
                        >
                          {item.field_link.title}
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </InView>
        )
      }
    )
}
